import { EmployeeSettingTypes } from "../../settings/enums/employeeSettingTypes";

export class EmployeeSettingViewModel {
  public id: number;
  public accountId: number;
  public employeeId: number;
  public title: number;
  public value: string;
  public settingType: EmployeeSettingTypes;
}
